import type { Locale } from "@i18n/react";
import { useLocale } from "@i18n/react";
import { useEffect, useRef } from "react";

import { APP_SESSION_STORAGE_KEY } from "../../lib/constants/appSession.constants";
import { useLocalStorageState } from "../../lib/utils/useLocalStorageState";
import { uuid } from "../../lib/utils/uuid";
import { useSession } from "../../session/hooks/useSession";

export const useHeadersValues = () => {
  const [appSession] = useLocalStorageState<string>({
    key: APP_SESSION_STORAGE_KEY,
    defaultValue: uuid(),
  });
  const locale = useLocale() as Locale;
  const { token } = useSession();

  const headersValues = useRef<{
    appSession: string;
    locale: Locale;
    token: string;
  }>({ appSession, locale, token });

  useEffect(() => {
    headersValues.current = { appSession, locale, token };
  }, [appSession, locale, token]);

  return headersValues;
};
